import { Container } from '@/platform/ui';
import PagePlaceholder from './components/PagePlaceholder';
import QuestionnaireEditPanel from './components/QuestionnaireEditPanel';

const QuestionnaireEditView = () => (
    <Container fluid>
        <PagePlaceholder />

        <QuestionnaireEditPanel />
    </Container>
);

export default QuestionnaireEditView;
